// UUID pattern: 8-4-4-4-12 hex digits
const UUID_REGEX = /^[a-f0-9]{8}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{12}$/i;
export class GameContextManager {
    constructor() {
        this.currentContext = null;
    }
    parseURL(url) {
        try {
            const urlObj = new URL(url);
            const pathname = urlObj.pathname;
            const params = {};
            // Parse query parameters
            urlObj.searchParams.forEach((value, key) => {
                params[key] = value;
            });
            // Pattern: /dashboard/games/{game_id}/{branch_name}/...
            // UUID pattern: [a-f0-9-]{36}
            const match = pathname.match(/\/dashboard\/games\/([a-f0-9-]{36})\/([^/]+)/);
            if (match) {
                const apiGameId = match[1];
                const branchName = match[2];
                // Get additional context from the full URL
                const urlPath = pathname.split('/dashboard/games/')[1];
                const pathParts = urlPath.split('/');
                const section = pathParts[2] || null;
                let subsection = pathParts[3] || null;
                let entityId = pathParts[4] || null;
                // Some sections use the pattern /section/{entityGuid} (no subsection),
                // e.g. /ui-builder/bd8fb5f2-122d-11f1-bc35-b1d9c463e2a8
                // Detect when subsection is actually an entity GUID and reclassify.
                if (subsection && UUID_REGEX.test(subsection) && !entityId) {
                    entityId = subsection;
                    subsection = null;
                }
                this.currentContext = {
                    isGamePage: true,
                    apiGameId: apiGameId,
                    branchName: branchName,
                    section,
                    subsection,
                    entityId,
                    environment: null,
                    version: null,
                    url,
                    pathname,
                    params,
                };
                console.log('[GameContextManager] Parsed game page context:', this.currentContext);
                return this.currentContext;
            }
            // Not on a game page
            this.currentContext = {
                isGamePage: false,
                apiGameId: null,
                branchName: null,
                section: null,
                subsection: null,
                entityId: null,
                environment: null,
                version: null,
                url,
                pathname,
                params,
            };
            console.log('[GameContextManager] Not on game page:', this.currentContext);
            return this.currentContext;
        }
        catch (error) {
            console.error('[GameContextManager] Failed to parse URL:', error);
            this.currentContext = {
                isGamePage: false,
                apiGameId: null,
                branchName: null,
                section: null,
                subsection: null,
                entityId: null,
                environment: null,
                version: null,
                url,
                pathname: '',
                params: {},
            };
            return this.currentContext;
        }
    }
    getCurrentContext() {
        return this.currentContext;
    }
    hasValidContext() {
        return !!(this.currentContext?.apiGameId && this.currentContext?.branchName);
    }
}
